var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "setting-field",
      class: { "disable-html-component": _vm.missing },
    },
    [
      _c(
        "el-badge",
        {
          staticClass: "label",
          attrs: { value: "error", hidden: !_vm.missing },
        },
        [_c("label", [_vm._v(" " + _vm._s(_vm.label) + " ")])]
      ),
      _vm._v(" "),
      _c("el-input", {
        attrs: { size: "small", disabled: !_vm.isAdmin },
        on: { change: _vm.onChange },
        model: {
          value: _vm.value,
          callback: function ($$v) {
            _vm.value = $$v
          },
          expression: "value",
        },
      }),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.error,
              expression: "error",
            },
          ],
          staticClass: "update-setting_error_msg",
        },
        [_vm._v(_vm._s(_vm.message))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }